import { locationToAddress, type PreventionListMeasureDTO } from '@ui/shared/util-api';

/**
 * Provider interface specific to the prevention-list application
 * Following the interface segregation principle
 */
export interface Provider {
    id: number;
    title: string;
    contactPerson?: string;
    phone?: string;
    email?: string;
    website?: string;
    address?: Array<string>;
}

/**
 * Maps a ProviderDTO from the API to our application-specific Provider interface
 *
 * @param measure The provider data from the API
 * @returns A Provider object with our application-specific structure
 */
export function mapProviderFromDTO(measure: PreventionListMeasureDTO): Provider {
    return {
        id: measure.provider.id,
        title: measure.provider.organization,
        contactPerson: measure.provider_contact?.contact_person,
        phone: measure.provider_contact?.phone,
        email: measure.provider_contact?.email,
        website: measure.provider.website ?? undefined,
        address: measure.provider.location ? locationToAddress(measure.provider.location) : undefined,
    };
}
